module.exports = __webpack_public_path__ + "static/media/journey_img.6663ae31.jpg";